import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaEnvelope,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-orange-50 via-purple-50 to-pink-50 border-t">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>
                <Link to="/contact-us" className="hover:text-blue-600">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:text-blue-600">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-blue-600">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">
              Policies
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>
                <Link to="/terms" className="hover:text-blue-600">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-blue-600">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="hover:text-blue-600">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">
              Connect With Us
            </h3>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/fetctrainingcentresurat/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800"
              >
                <FaFacebook size={20} />
              </a>
              <a
                href="https://www.linkedin.com/company/96215379/admin/feed/posts/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:text-blue-700"
              >
                <FaLinkedin size={20} />
              </a>
              <a
                href="https://www.instagram.com/fetc_trainingcentre"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-500 hover:text-pink-700"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="mailto:info@fetc.in"
                className="text-red-500 hover:text-red-700"
              >
                <FaEnvelope size={20} />
              </a>
            </div>
          </div>

          {/* Logo */}
          <div className="flex items-start lg:justify-end">
            <img
              src="/image/logo/gina-abroad.png"
              alt="Gina Abroad"
              className="w-36 object-contain"
            />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t mt-10 pt-4 text-center text-xs text-gray-600">
          © {new Date().getFullYear()}{" "}
          <Link to="/" className="font-semibold hover:text-blue-600">
            FETC
          </Link>{" "}
          · All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
